import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "control", "rules", "defaultValue", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid } from '@mui/material';
import clsx from 'clsx';
import { cloneDeep } from 'lodash';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveCheckboxGroupFormControlSXTypeEnum;

(function (JoveCheckboxGroupFormControlSXTypeEnum) {
  JoveCheckboxGroupFormControlSXTypeEnum["normal"] = "normal";
  JoveCheckboxGroupFormControlSXTypeEnum["small"] = "small";
})(JoveCheckboxGroupFormControlSXTypeEnum || (JoveCheckboxGroupFormControlSXTypeEnum = {}));

var JoveCheckboxGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      options = props.options,
      defaultValue = props.defaultValue,
      value = props.value,
      valueChange = props.valueChange,
      error = props.error,
      errMessage = props.errMessage,
      rowNumber = props.rowNumber,
      disabled = props.disabled,
      singleChoose = props.singleChoose,
      _props$cannotEmpty = props.cannotEmpty,
      cannotEmpty = _props$cannotEmpty === void 0 ? true : _props$cannotEmpty,
      checkboxFormControlSXType = props.checkboxFormControlSXType,
      checkboxFormClassName = props.checkboxFormClassName;

  var _useState = useState(defaultValue || (singleChoose ? '' : [])),
      selectValue = _useState[0],
      setSelectValue = _useState[1];

  var _useState2 = useState(checkboxFormControlSXType === JoveCheckboxGroupFormControlSXTypeEnum.small ? {
    '& .MuiTypography-root': {
      fontSize: '14px',
      fontWeight: 500
    },
    height: '24px'
  } : null),
      checkboxFormControlSX = _useState2[0];
  /**
   * effects
   */


  useEffect(function () {
    setSelectValue(value || (singleChoose ? '' : []));
  }, [value]);
  /**
   * methods
   */

  var checkboxChangeAction = function checkboxChangeAction(item, checked) {
    var data = null;

    if (singleChoose) {
      if (checked) {
        data = item.value;
      } else {
        if (cannotEmpty) {
          return;
        } else {
          data = '';
        }
      }
    } else {
      if (checked) {
        selectValue.push(item.value);
        data = cloneDeep(selectValue);
      } else {
        data = cloneDeep(selectValue.filter(function (aItem) {
          return aItem !== item.value;
        }));
      }
    }

    if (value === undefined) {
      setSelectValue(data);
    } else {
      valueChange === null || valueChange === void 0 ? void 0 : valueChange(data);
    }
  };

  var haveList = value === undefined ? selectValue : value || (singleChoose ? '' : []);
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsx(FormControl, {
      disabled: disabled,
      component: "fieldset",
      variant: "standard",
      children: /*#__PURE__*/_jsx(FormGroup, {
        row: true,
        children: /*#__PURE__*/_jsx(Grid, {
          container: true,
          justifyContent: "space-between",
          alignItems: "center",
          children: (options || []).map(function (item) {
            return /*#__PURE__*/_jsx(Grid, {
              item: true,
              xs: rowNumber ? 12 / rowNumber : 4,
              children: /*#__PURE__*/_jsx(FormControlLabel, {
                control: /*#__PURE__*/_jsx(Checkbox, {
                  checked: haveList === null || haveList === void 0 ? void 0 : haveList.includes(item.value),
                  onChange: function onChange(e, checked) {
                    return checkboxChangeAction(item, checked);
                  },
                  name: "gilad",
                  size: "small",
                  className: checkboxFormClassName ? clsx(checkboxFormClassName) : undefined
                }),
                label: item.label,
                sx: checkboxFormControlSX
              })
            }, item.value);
          })
        })
      })
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    })]
  });
});
export var JoveCheckboxGroupControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;
  /**
   * methods
   */


  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-col",
    children: /*#__PURE__*/_jsx(JoveCheckboxGroup, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveCheckboxGroup;